import React from 'react'
import styled from 'styled-components'

interface StyledButton {
  width?: string;
  background?: string;
  color?: string;
  border?: string;
  disabled?: boolean;
}

const StyledButton = styled.button<StyledButton>`
  width: ${props => props.width || "100px"};
  height: 30px;
  /* padding: 10px 20px; */
  background: ${props => props.background || "#000"};
  color: ${props => props.color || "#FFF"};
  border: ${props => props.border || "0"};
  position: relative;
  display: block;
  text-align: center;
  margin: 5px;
  
  span {
    width: 100%;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%) translateX(-50%);
    transform: translateY(-50%) translateX(-50%);
  }
  
  &:hover {
    cursor: pointer;
    // box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
  }
`;

export const Button = ({ disabled, border, color, width, background, children, onClick }: { disabled?: boolean; border?: string, color?: string, width?: string, background?: string, children: React.ReactNode, onClick?: any }) => {

  return (
    <StyledButton disabled={false} border={border} color={color} width={width} background={background} onClick={onClick}>
      <span>
      {children}
      </span>
    </StyledButton>
  )
}